const { createContext } = require("react");

const TransactionEditContext = createContext({
  isInTransactionEditContext: false,
  transactionId: null,
});

export default TransactionEditContext;
